module.exports = __webpack_public_path__ + "img/11.1fa881fa.jpg";